import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged, map } from 'rxjs';

/**
 * Whether anything on screen shows the plan's findings. A check the user did not ask for is only
 * started while one does, so its progress and any failure are reported where they can be read.
 */
@Injectable({ providedIn: 'root' })
export class FindingsVisibilityService {
  private readonly viewers = new BehaviorSubject(0);

  readonly visible$: Observable<boolean> = this.viewers.pipe(
    map((count) => count > 0),
    distinctUntilChanged()
  );

  get visible(): boolean {
    return this.viewers.value > 0;
  }

  /** Returns the matching release, to be called when the view goes away. */
  show(): () => void {
    this.viewers.next(this.viewers.value + 1);
    let released = false;
    return () => {
      if (released) return;
      released = true;
      this.viewers.next(this.viewers.value - 1);
    };
  }
}
